module.exports = __webpack_public_path__ + "static/30-84fe6f9f42e3632ca0b4a8ef697d1008.jpg";